export enum MedcardGpdIds {
  Lab = 301,
  Radiology = 302,
  Examination = 306
}
